import { combineReducers } from 'redux';
import apiReducer from './api/reducer';
import appReducer from './application/reducer';
import authReducer from './authentication/reducer';
import formReducer from './form/reducer';
import saveReducer from './save/reducer';
import sectionReducer from './section/reducer';
import settingsReducer from './settings/reducer';
import featureFlagsReducer from './featureFlags/reducer';

const rootReducer = combineReducers({
  api: apiReducer,
  application: appReducer,
  authentication: authReducer,
  featureFlags: featureFlagsReducer,
  form: formReducer,
  save: saveReducer,
  section: sectionReducer,
  settings: settingsReducer,
});

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer;
